//
// 基础路径--生产环境
const baseURL = window.location.protocol + '//' + window.location.host;
// const baseURL = 'https://www.jingxuanwenhua.com';
// 基础路径--测试环境 (使用代理)
// const baseURL = 'https://test.aismartbox.cn';
// const baseURL = 'http://192.168.1.105:8080';
// const baseURL = 'http://233d53fe.r27.cpolar.top';
const fetchApiUrl = baseURL + '/sse/chat';
// const upload = baseURL + '/oss/upload';
const upload = baseURL + '/oss/uploadFile';
const VUE_APP_VERSION = '1.0.11';
export {
  baseURL,
  fetchApiUrl,
  upload,
  VUE_APP_VERSION
};
